/**
 * @Author: 左建
 * @Date: 2022/8/30 16:26
 * @LastEditTime: 2022/8/30 16:26
 * @Description: 课程相关配置
 */

export const TABS_LIST = Object.freeze([
    {
        label: "发布最晚",
        value: "later",
        sortOrder: "desc",
        sortBy: "AddTime"
    },
    {
        label: "发布最早",
        value: "early",
        sortOrder: "asc",
        sortBy: "AddTime"
    },
    {
        label: "最受欢迎",
        value: "popular",
        sortOrder: "desc",
        sortBy: "HotValue"
    },
])

// 获取初始化课程列表
export function getInitCourseList() {
    return TABS_LIST.reduce((preVal, curVal) => {
        preVal[curVal.value] = []
        return preVal
    }, {})
}

// 获取初始化pagination
export function getInitPagination(mergeObj) {
    return TABS_LIST.reduce((preVal, curVal) => {
        const pagination = {
            pageIndex: 1,
            pageSize: 10,
            total: 10
        }
        preVal[curVal.value] = Object.isObj(mergeObj) ? Object.assign(pagination, mergeObj) : pagination
        return preVal
    }, {})
}

// 获取初始化查询参数(不包括分页)
export function getInitSearchParams(mergeObj) {
    return TABS_LIST.reduce((preVal, curVal) => {
        const searchParams = {
            keyWord: undefined,
            sortBy: curVal.sortBy,
            ClassLevel: undefined,
            sortOrder: curVal.sortOrder
        }
        preVal[curVal.value] = Object.isObj(mergeObj) ? Object.assign(searchParams, mergeObj) : searchParams
        return preVal
    }, {})
}
